module.exports = __webpack_public_path__ + "static/banner-four-shape10-c254a53dfa18bdb8afc8dc3baedf759e.png";